<div class="bg-white background">
</div>
<app-menu-template5>
  <!-- <div class="col-sm-6 p-0 contactenos-bg-img-rectangle">
    <img class="col-sm-12 p-0" src="../../../../../assets/images/contactenos.jpg" />
  </div> -->
  <main class="container-fluid">
    <article class="row">
      <aside class="col-md-6 bg p-5">
        <header class="text-white ml-5 text-header pt-5">
          <!--ml-5-->
          <h1>Estimado usuario</h1>
          <p>Sus opiniones son muy importantes para nosotros. Por favor llene el formulario con sus datos nos
            comunicaremos con usted.
          </p>
          <p>Esta información será recibida por la Cámara de Comercio quien atenderá cualquier inquietud que se
            presente
            con los trámites de su registro.</p>
        </header>
      </aside>
      <section class="col-md-6 mt-4">
        <h1 class="h3 col-12 m-auto pb-3 form ">Contáctenos</h1>
        <form class="col-12 m-auto form" [formGroup]="formContactenos" (ngSubmit)="enviarFormulario()">
          <div class="form-row mb-3">
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary required" for="nombre">Nombre</label>
              <input id="nombre" formControlName="nombres" class="form-control" type="text">
            </div>
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary required" for="numero_telefonico">Teléfono</label>
              <input id="numero_telefonico" formControlName="numero_telefonico" class="form-control" type="text">
              <div id="mensaje"
                *ngIf="!formContactenos.controls.numero_telefonico.valid  && (formContactenos.get('numero_telefonico').dirty)">
                <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Solo se permiten
                  valores numéricos</p>
              </div>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary required" for="correo">Correo eletrónico</label>
              <input id="correo" formControlName="correo_electronico" class="form-control" type="email">
              <div id="mensaje"
                *ngIf="!formContactenos.controls.correo_electronico.valid  && (formContactenos.get('correo_electronico').dirty)">
                <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Dígite
                  un correo válido</p>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary" for="establecimiento">Nombre de establecimiento</label>
              <input id="establecimiento" formControlName="nombre_establecimiento" class="form-control" type="text">
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary required" for="nit">Identificación</label>
              <input id="nit" formControlName="nit" class="form-control" type="text">
              <div id="mensaje" *ngIf="!formContactenos.controls.nit.valid  && (formContactenos.get('nit').dirty)">
                <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Dígite
                  únicamente valores numéricos</p>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary" for="numero_rnt">Número RNT</label>
              <input id="numero_rnt" formControlName="numero_rnt" class="form-control" type="text">
              <div id="mensaje"
                *ngIf="!formContactenos.controls.numero_rnt.valid  && (formContactenos.get('numero_rnt').dirty)">
                <p class="small text-danger mt-1 position-absolute font-weight-bold font-weight-bold" text-right>Dígite
                  únicamente valores numéricos</p>
              </div>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary required" for="departamento">Departamento</label>
              <select id="departamento" formControlName="departamento_id" class="form-control" (change)="onMunicipio()">
                <ng-container *ngFor="let item of departamentos">
                  <option [ngValue]="item.departamento_id">{{item.descripcion}}</option>
                </ng-container>
              </select>
            </div>
            <div class="col-sm-12 col-md-6 form-group m-auto">
              <label class="small text-secondary required" for="municipio">Municipio</label>
              <select id="municipio" formControlName="municipio_id" class="form-control">
                <ng-container *ngFor="let item of municipios">
                  <option [ngValue]="item.municipio_id">{{item.descripcion}}</option>
                </ng-container>
              </select>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-sm-12 form-group m-auto">
              <label class="small text-secondary required" for="mensaje">Mensaje</label>
              <textarea id="mensaje" formControlName="mensaje_enviado" class="form-control h-100"
                type="text"></textarea>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-sm-12 form-group m-auto">
              <input id="acepta_termino" type="checkbox" class="form-check d-inline-block"
                formControlName="acepta_termino">
              <label class="small text-secondary form-check-label" for="acepta_termino" [innerHTML]="terminos"></label>
              <a class="small text-primary p-2 pointer" (click)="openModalTermino()">Ver terminos</a>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-12 text-center">
              <re-captcha formControlName="captcha" class="d-inline-block"></re-captcha>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col form-group text-center">
              <button type="submit" [disabled]="!formContactenos.valid"
                class="btn btn-contact text-white">Enviar</button>
            </div>
          </div>
        </form>
      </section>
    </article>
  </main>
</app-menu-template5>